import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote } from "lucide-react";
import { fetchTestimonials } from "@/lib/api";

export default function Testimonials() {
    const [items, setItems] = useState([]);
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        let alive = true;
        fetchTestimonials()
            .then((rows) => {
                if (alive) setItems(rows);
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    useEffect(() => {
        if (items.length < 2) return;
        const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 5500);
        return () => clearInterval(t);
    }, [items.length]);

    if (items.length === 0) return null;
    const current = items[idx];

    return (
        <section
            className="mm-section bg-white"
            data-testid="testimonials-section"
        >
            <div className="mm-container">
                <div className="mx-auto max-w-3xl text-center">
                    <div className="mm-eyebrow mb-3">What clients say</div>
                    <div className="relative min-h-[200px]">
                        <AnimatePresence mode="wait">
                            <motion.figure
                                key={current.id}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -8 }}
                                transition={{ duration: 0.45 }}
                                className="flex flex-col items-center"
                                data-testid="testimonial-card"
                            >
                                <Quote className="mb-5 text-mm-sky" size={28} />
                                <blockquote className="mm-display text-2xl sm:text-3xl text-mm-navy leading-snug">
                                    &ldquo;{current.quote}&rdquo;
                                </blockquote>
                                <figcaption className="mt-6 text-sm text-mm-muted">
                                    — {current.attribution}
                                </figcaption>
                            </motion.figure>
                        </AnimatePresence>
                    </div>

                    <div className="mt-8 flex justify-center gap-2">
                        {items.map((t, i) => (
                            <button
                                key={t.id}
                                onClick={() => setIdx(i)}
                                aria-label={`Go to testimonial ${i + 1}`}
                                className={`h-1.5 rounded-full transition-all ${
                                    i === idx
                                        ? "w-8 bg-mm-navy"
                                        : "w-2 bg-mm-line hover:bg-mm-navy/40"
                                }`}
                                data-testid={`testimonial-dot-${i}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
